document.addEventListener('bundler:bundle_widget_created', function(e) {
// e.detail contains the current products in the bundle
console.log('DEBUG: Bundle loaded', e.detail.products);
});
$(document).ready(function () { 
var trigger1_faceCondition = 0;
var trigger2_eyeConcern = 0; 
var trigger3_skinGoal = 0;
var tried = "yes";
var current_question = 0;
var chosen;
var score = Math.floor(Math.random() * 11) + 70; // Random score between 70-80
var fname = "";
var answers;
var selected = false;
var introduction_html = $(".introduction").html();
// Product mapping using product IDs (extracted from Shopify admin URLs)
// Trigger 1: Cleanser mapping based on trigger3_skinGoal (question 4)
var q4_faceConditionCleanserIds = {
0: ["2016495599686"], // Dry or parched: Down to Earth
1: ["2016495599686"], // Same as when you woke up: Down to Earth
2: ["14709559951723"], // Oily or shiny: Quality Control
};
// Trigger 2: Eye cream mapping based on trigger2_eyeConcern (question 5)
var q5_eyeConcernProductIds = {
0: ["6888107442279"], // Fine lines: Wonderfill
1: ["2016637681734"], // Puffiness: All In
2: ["14841599656299"], // Dark Circles: Tide & True
3: ["14669128597867"], // Prevention: Retinol Eye Cream
};
// Trigger 3: Main products by skin improvement type (2 products each)
var q6_skinGoalProductIds = {
0: ["6914698281063", "2016512737350"], // Complexion/Discoloration: OCIN + Cloud Whip
1: ["4480408027239", "7031474421863"], // Aging/wrinkles: Seeking C + Smooth Sailing
2: ["2016630308934", "6657636302951"], // Daily Skincare: Pep Rally + Up the Anti
3: ["6914698281063", "2016461226054"], // Acne/oily: OCIN + Daydreamer
4: ["4480408027239", "6657636302951"], // Redness/rosacea: Seeking C + Up the Anti
5: ["2016630308934", "2016624705606"], // Sensitive: Pep Rally + Night Shift
};
// ========================================
// DEBUG CONSOLE FUNCTION
// ========================================
function logDebugInfo() {
// Get the human-readable answers
var trigger1Answer = questions[3].options[trigger1_faceCondition].option;
var trigger2Answer = questions[4].options[trigger2_eyeConcern].option;
var trigger3Answer = questions[5].options[trigger3_skinGoal].option;
// Get the product IDs
var trigger1ProductId = q4_faceConditionCleanserIds[trigger1_faceCondition];
var trigger2ProductId = q5_eyeConcernProductIds[trigger2_eyeConcern];
var trigger3ProductIds = q6_skinGoalProductIds[trigger3_skinGoal];
var trigger1Products = [];
if (trigger1ProductId) {
trigger1Products = trigger1ProductId.map(id => {
productTitle = $(`.results-product[data-product-id="${id}"]`).find('.card__information a.full-unstyled-link:first').text().trim();
return productTitle + ` | ID ${id}`;
});
}
var trigger2Products = [];
if (trigger2ProductId) {
trigger2Products = trigger2ProductId.map(id => {
productTitle = $(`.results-product[data-product-id="${id}"]`).find('.card__information a.full-unstyled-link:first').text().trim();
return productTitle + ` | ID ${id}`;
});
}
var trigger3Products = [];
if (trigger3ProductIds) {
trigger3Products = trigger3ProductIds.map(id => {
productTitle = $(`.results-product[data-product-id="${id}"]`).find('.card__information a.full-unstyled-link:first').text().trim();
return productTitle + ` | ID ${id}`;
});
}
console.log("%c╔════════════════════════════════════════════════════════════╗", "color: #60a5fa; font-weight: bold;");
console.log("%c║                  QUIZ DEBUG MODE                           ║", "color: #fbbf24; font-weight: bold;");
console.log("%c╚════════════════════════════════════════════════════════════╝", "color: #60a5fa; font-weight: bold;");
console.log("");
console.log("%c┌─ TRIGGER 1: CLEANSER ─────────────────────────────────────┐", "color: #60a5fa; font-weight: bold;");
console.log("%c│ Answer:     %c" + trigger1Answer, "color: #9ca3af;", "color: #a3e635; font-weight: bold;");
console.log("%c│ Products: %c" + (trigger1Products.length > 0 ? trigger1Products.join("\n") : 'N/A'), "color: #9ca3af;", "color: #fbbf24; font-weight: bold;");
console.log("%c└───────────────────────────────────────────────────────────┘", "color: #60a5fa;");
console.log("");
console.log("%c┌─ TRIGGER 2: EYE CREAM ────────────────────────────────────┐", "color: #60a5fa; font-weight: bold;");
console.log("%c│ Answer:     %c" + trigger2Answer, "color: #9ca3af;", "color: #a3e635; font-weight: bold;");
console.log("%c│ Products: %c" + (trigger2Products.length > 0 ? trigger2Products.join("\n") : 'N/A'), "color: #9ca3af;", "color: #fbbf24; font-weight: bold;");
console.log("%c└───────────────────────────────────────────────────────────┘", "color: #60a5fa;");
console.log("");
console.log("%c┌─ TRIGGER 3: MAIN PRODUCTS ────────────────────────────────┐", "color: #60a5fa; font-weight: bold;");
console.log("%c│ Answer:      %c" + trigger3Answer, "color: #9ca3af;", "color: #a3e635; font-weight: bold;");
console.log("%c│ Products:\n %c" + (trigger3Products.length > 0 ? trigger3Products.join("\n.") : 'N/A'), "color: #9ca3af;", "color: #fbbf24; font-weight: bold;");
console.log("%c└───────────────────────────────────────────────────────────┘", "color: #60a5fa;");
console.log("");
}
// Check for ?retake=1 query parameter to clear cookies
var urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('retake') === '1') {
Cookies.remove("score");
Cookies.remove("fname");
Cookies.remove("trigger1_faceCondition");
Cookies.remove("tried");
Cookies.remove("trigger3_skinGoal");
Cookies.remove("trigger2_eyeConcern");
Cookies.remove("taken");
// Redirect to clean URL without query string
window.location.href = window.location.pathname;
}
// TESTING: Override triggers via URL parameters
// Example: ?test=1&trigger1=0&trigger2=0&trigger3=0&tried=0
if (urlParams.get('test') === '1') {
let newcustomer = 'yes';
if (urlParams.has('trigger1')) trigger1_faceCondition = parseInt(urlParams.get('trigger1'));
if (urlParams.has('trigger2')) trigger2_eyeConcern = parseInt(urlParams.get('trigger2'));
if (urlParams.has('trigger3')) trigger3_skinGoal = parseInt(urlParams.get('trigger3'));
if (urlParams.has('tried')) newcustomer = urlParams.get('tried');
tried = newcustomer === 'yes' ? 0 : 1; // Convert to 0/1 for "Yes"/"No"
// Save to cookies and show results immediately
Cookies.set("trigger3_skinGoal", trigger3_skinGoal);
Cookies.set("trigger2_eyeConcern", trigger2_eyeConcern);
Cookies.set("trigger1_faceCondition", trigger1_faceCondition);
Cookies.set("tried", tried);
Cookies.set("score", Math.floor(Math.random() * 11) + 70);
Cookies.set("fname", "Test User");
showResults();
setTimeout(function() {
logDebugInfo();
}, 100);
$(".results").show();
$(".question, .introduction, .email").hide();
}
KlaviyoSubscribe.attachToForms(".email form", {
hide_form_on_success: true,
});
var questions = [
{
question: "What is your age?",
options: [
{
option: "18 – 25",
value: 0,
},
{
option: "26 – 35",
value: -2,
},
{
option: "35 – 45",
value: -5,
},
{
option: "45 – 60",
value: -8,
},
{
option: "60+",
value: -10,
},
],
},
{
question: "How many hours of sleep do you get a night?",
options: [
{
option: "1 - 4",
value: -5,
},
{
option: "5 - 6",
value: 0,
},
{
option: "7+",
value: 1,
},
],
},
{
question: "How many glasses of water do you drink daily?",
options: [
{
option: "1 - 3",
value: -4,
},
{
option: "4 - 5",
value: 1,
},
{
option: "6 - 7",
value: 3,
},
{
option: "8+",
value: 5,
},
],
},
{
question: "At the end of the day, does your face look:",
options: [
{
option: "Dry or parched",
value: 0,
},
{
option: "Same as when you woke up",
value: 0,
},
{
option: "Oily or shiny",
value: 0,
},
],
},
{
question: "What are your main eye area concerns?",
options: [
{
option: "Fine lines",
value: 0,
},
{
option: "Puffy",
value: 0,
},
{
option: "Dark Circles",
value: 0,
},
{
option: "Prevention",
value: 0,
},
],
},
{
question: "What about your skin would you most like to improve?",
options: [
{
option: "Complexion/Discoloration",
value: 0,
},
{
option: "Aging/wrinkles",
value: 1,
},
{
option: "Daily Skincare routine",
value: 2,
},
{
option: "Acne/oily skin",
value: 3,
},
{
option: "Redness/rosacea",
value: 4,
},
{
option: "Sensitive skin",
value: 5,
},
],
},
{
question: "Have you tried Eight Saints Skincare?",
options: [
{
option: "Yes",
value: 0,
},
{
option: "No",
value: 0,
},
],
},
];
if (Cookies.get("score")) {
score = Math.floor(Cookies.get("score"));
fname = Cookies.get("fname");
trigger1_faceCondition = Cookies.get("trigger1_faceCondition");
trigger2_eyeConcern = Cookies.get("trigger2_eyeConcern");
trigger3_skinGoal = Cookies.get("trigger3_skinGoal");
tried = Cookies.get("tried");
showResults();
$(".results").show();
$(".question, .introduction").hide();
} else {
$(".skin-quiz").addClass("started");
answers = [];
$(".back").hide();
var question = questions[current_question];
$(".question").not(".email").show();
$(".question h2").text(question.question);
loadQuestions(question);
}
$(".retake").click(function (e) {
e.preventDefault();
Cookies.remove("score");
Cookies.remove("fname");
Cookies.remove("trigger1_faceCondition");
Cookies.remove("tried");
Cookies.remove("trigger3_skinGoal");
Cookies.remove("trigger2_eyeConcern");
score = Math.floor(Math.random() * 11) + 70; // Random score between 70-80
answers = [];
$(".introduction").after(
'<div class="introduction">' + introduction_html + "</div>"
);
$(".introduction").first().remove();
$("html, body").animate(
{
scrollTop: 1,
},
200
);
$(".results").hide();
current_question = 0;
$(".options").empty();
current_question = 0;
var question = questions[current_question];
$(".question").not(".email").show();
$(".question h2").text(question.question);
loadQuestions(question);
});
$(".back").click(function () {
$(".option.selected").removeClass("selected");
current_question--;
if (current_question == 0) {
$(".back").hide();
}
score -=
questions[current_question].options[answers[current_question]].value;
var question = questions[current_question];
$(".question h2").text(question.question);
$(".options").empty();
loadQuestions(question);
answers.pop();
});
function showProducts(products, label, triggerValue) {
if (!Array.isArray(products)) return;
products.forEach(productId => {
$(`.results-product[data-product-id="${productId}"]`).show();
});
}
function removeQuizAdInputsIfTried() {
console.log('Tried', tried);
if (Number(tried) === 0) { // Only remove quiz ad inputs for customers, not prospects
$('.quiz_result_ad_control').remove();
}
}
function showResults() {
Cookies.set("taken", 1);
removeQuizAdInputsIfTried();
// if (Number(tried) === 1) {
  
// }
// tried == 0 means "Yes" (customer) - show individual products
// tried == 1 means "No" (prospect) - redirect to new customer bundle
$(".results .results-product").hide();
const trigger1Products = q4_faceConditionCleanserIds[trigger1_faceCondition];
const trigger2Products = q5_eyeConcernProductIds[trigger2_eyeConcern];
const trigger3Products = q6_skinGoalProductIds[trigger3_skinGoal];
showProducts(trigger1Products, 'Trigger 1', trigger1_faceCondition);
showProducts(trigger2Products, 'Trigger 2', trigger2_eyeConcern);
showProducts(trigger3Products, 'Trigger 3', trigger3_skinGoal);
document.querySelectorAll('.score').forEach(el => el.textContent = `Your score is ${score} out of 100.`);
if (Number(tried) === 0) {
  // YES - Existing Customer: Show normal Hero, hide Discovery Hero
  $(".results-hero").show();
  $(".results-hero-discovery").hide();
  $(".results .products").show();
  $(".results .discovery_container").hide();
} else {
  // NO - New Customer / Prospect: Show Discovery Hero, hide normal Hero
  $(".results-hero").hide();
  $(".results-hero-discovery").show();
  $(".results .products").show();
  $(".inside_kit").hide(); 
  $(".bundle-banner-block").show();
  $(".results .discovery_container").show();
}
var hasBundler = false;
if (tried == 0) {
  // Subscription Routine Bundler
  window.BoxConfig = {
  template: 'product',
  designMode: false,
  layoutTemplate: "one-page",
  product: {"id":14859573723499,"title":"Subscription Routine Bundler - Categories","handle":"subscription-routine-bundler-categories","description":null,"published_at":"2026-01-28T23:27:58-05:00","created_at":"2025-12-11T11:46:50-05:00","vendor":"Eight Saints","type":"hidden","tags":[],"price":0,"price_min":0,"price_max":0,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":52667286094187,"title":"Default Variant","option1":"Default Variant","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"Subscription Routine Bundler - Categories - Default Variant","public_title":"Default Variant","options":["Default Variant"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692205060459,"selling_plan_group_id":"12d55eca2768089b9282160b789b601ff23b1e93"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692205125995,"selling_plan_group_id":"6c45eee619efe23969118f5abb9d14e05c1b1422"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692205158763,"selling_plan_group_id":"21632555a188edd685d6d9bcdb3f4bdbc7cbbed0"}],"quantity_rule":{"min":1,"max":null,"increment":1}}],"images":["\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/eight_saints_byob_0422beb1-1303-4495-bc4d-86b62a5a3861.webp?v=1762564423"],"featured_image":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/eight_saints_byob_0422beb1-1303-4495-bc4d-86b62a5a3861.webp?v=1762564423","options":["Title"],"media":[{"alt":null,"id":45524746142059,"position":1,"preview_image":{"aspect_ratio":1.0,"height":1000,"width":1000,"src":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/eight_saints_byob_0422beb1-1303-4495-bc4d-86b62a5a3861.webp?v=1762564423"},"aspect_ratio":1.0,"height":1000,"media_type":"image","src":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/eight_saints_byob_0422beb1-1303-4495-bc4d-86b62a5a3861.webp?v=1762564423","width":1000}],"requires_selling_plan":false,"selling_plan_groups":[{"id":"12d55eca2768089b9282160b789b601ff23b1e93","name":"Delivery every 30 days","options":[{"name":"Recharge Plan ID","position":1,"values":["20412516"]},{"name":"Order Frequency and Unit","position":2,"values":["30-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692205060459,"name":"Delivery every 30 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20412516"},{"name":"Order Frequency and Unit","position":2,"value":"30-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"6c45eee619efe23969118f5abb9d14e05c1b1422","name":"Delivery every 60 days","options":[{"name":"Recharge Plan ID","position":1,"values":["20412518"]},{"name":"Order Frequency and Unit","position":2,"values":["60-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692205125995,"name":"Delivery every 60 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20412518"},{"name":"Order Frequency and Unit","position":2,"value":"60-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"21632555a188edd685d6d9bcdb3f4bdbc7cbbed0","name":"Delivery every 90 days","options":[{"name":"Recharge Plan ID","position":1,"values":["20412519"]},{"name":"Order Frequency and Unit","position":2,"values":["90-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692205158763,"name":"Delivery every 90 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20412519"},{"name":"Order Frequency and Unit","position":2,"value":"90-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"}],"content":null}
  };
  if ($('.customer-bundler-section').length || $('#customer-bundler-section').length){
  hasBundler = true;
  $('.customer-bundler-section, #customer-bundler-section').show();
  }
} else { 
  
  // $(".results .products").hide();
  
  $('.quiz-new25-offer').removeClass('quiz-new25-offer');
  $('#quiz-new25-offer').attr('id', 'quiz-new25-offer-visible');

// New Customer Build Your Routine
window.BoxConfig = {
template: 'product',
designMode: false,
layoutTemplate: "one-page",
product: {"id":14737081991531,"title":"New Customer Build Your Routine - Subscription","handle":"new-customer-bundle","description":null,"published_at":"2025-07-15T11:40:29-04:00","created_at":"2025-07-15T11:39:03-04:00","vendor":"Eight Saints","type":"hidden","tags":["free_shipping","hidden","Hidden Product","limit_one","new_customer_bundle","one_time_offer","SEARCHANISE_IGNORE"],"price":0,"price_min":0,"price_max":0,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":52197851070827,"title":"Default Variant","option1":"Default Variant","option2":null,"option3":null,"sku":"WELCOME-BUNDLE","requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"New Customer Build Your Routine - Subscription - Default Variant","public_title":"Default Variant","options":["Default Variant"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":"shopify","barcode":"","requires_selling_plan":true,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692128285035,"selling_plan_group_id":"1a3005ca69ae07d82fe2bce36f56bbc02a05d640"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692128252267,"selling_plan_group_id":"23582f2d59bcbc4b942dcb174b069c83b9ea4b94"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":692128219499,"selling_plan_group_id":"46ab620005bd1ead04dea13aec966f4f4475bc1b"}],"quantity_rule":{"min":1,"max":null,"increment":1}}],"images":["\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/custom_skincare_bundle.webp?v=1762569092"],"featured_image":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/custom_skincare_bundle.webp?v=1762569092","options":["Title"],"media":[{"alt":null,"id":46196812775787,"position":1,"preview_image":{"aspect_ratio":1.0,"height":1500,"width":1500,"src":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/custom_skincare_bundle.webp?v=1762569092"},"aspect_ratio":1.0,"height":1500,"media_type":"image","src":"\/\/eight-saints.myshopify.com\/cdn\/shop\/files\/custom_skincare_bundle.webp?v=1762569092","width":1500}],"requires_selling_plan":true,"selling_plan_groups":[{"id":"1a3005ca69ae07d82fe2bce36f56bbc02a05d640","name":"30 day subscription","options":[{"name":"Recharge Plan ID","position":1,"values":["20087944"]},{"name":"Order Frequency and Unit","position":2,"values":["30-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692128285035,"name":"30 day subscription","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20087944"},{"name":"Order Frequency and Unit","position":2,"value":"30-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"23582f2d59bcbc4b942dcb174b069c83b9ea4b94","name":"45 day subscription","options":[{"name":"Recharge Plan ID","position":1,"values":["20087945"]},{"name":"Order Frequency and Unit","position":2,"values":["45-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692128252267,"name":"45 day subscription","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20087945"},{"name":"Order Frequency and Unit","position":2,"value":"45-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"46ab620005bd1ead04dea13aec966f4f4475bc1b","name":"60 day subscription","options":[{"name":"Recharge Plan ID","position":1,"values":["20087946"]},{"name":"Order Frequency and Unit","position":2,"values":["60-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":692128219499,"name":"60 day subscription","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"20087946"},{"name":"Order Frequency and Unit","position":2,"value":"60-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"}],"content":null}
};
console.log('DEBUG', $('.results-hero-discovery').length);
if (($('.new-customer-section').length || $('#new-customer-section').length) && !$('.inside_kit').length ){
hasBundler = true;
$('.new-customer-section, #new-customer-section').show();
}
if ($('.inside_kit').length){
// $('.inside_kit').show();
}
}
if (hasBundler == true) {
const script = document.createElement('script');
script.src = 'https://static.rechargecdn.com/assets/bundling-widget/src.js';
script.defer = true;
script.referrerPolicy = 'origin';
document.body.appendChild(script);
$('#recharge-bundles, .bundle-banner-block').show();
window.rechargeWidgetRendered = false;
document.addEventListener("bundling-widget:ready", (event) => {
if (window.rechargeWidgetRendered) return; // Prevent duplicate execution if event fires multiple times
window.rechargeWidgetRendered = true;
if (tried == 1) { // Prospect sees new customer bundle - insert free gift ad after 1 second
setTimeout(function() {
const targetCarddesktop = document.querySelector('[data-rb-item-id="14737153982827"]');
if (targetCarddesktop) {
const adDivdesktop = document.createElement('div');
adDivdesktop.className = 'nc-grid-ad desktop-show-bundle';
adDivdesktop.innerHTML = '<img class="c-ad" src="https://cdn.shopify.com/s/files/1/0076/5453/9334/files/freegifts-desktop-v2_bb35d2be-89b7-4bad-9343-33ec99739083.webp?v=1751035381" width="100%" height="auto"/>';
targetCarddesktop.after(adDivdesktop);      
};
//create new div for after wonderfill product card-mobile
const targetCardmobile = document.querySelector('[data-rb-item-id="14737152999787"]');
if (targetCardmobile) {
const adDivmobile = document.createElement('div');
adDivmobile.className = 'nc-grid-ad mobile-show';
adDivmobile.innerHTML = '<img class="c-ad" src="https://cdn.shopify.com/s/files/1/0076/5453/9334/files/freegifts-mobile-v2_fd8f27ed-f6f9-432c-ae2f-e6e89c6d1b29.webp?v=1751035381" width="100%" height="auto"/>';
targetCardmobile.after(adDivmobile);      
};
//create new div for after daydreamerproduct card-ipad
const targetCardipad = document.querySelector('[data-rb-item-id="14737154638187"]');
if (targetCardipad) {
const adDivipad = document.createElement('div');
adDivipad.className = 'nc-grid-ad ipad-show-bundle';
adDivipad.innerHTML = '<img class="c-ad" src="https://cdn.shopify.com/s/files/1/0076/5453/9334/files/freegifts-ipad-v2_3e984e46-929d-488d-a548-6c828228a357.webp?v=1751035382" width="100%" height="auto"/>';
targetCardipad.after(adDivipad);      
};
}, 1000);
}
});
}
}
function loadQuestions(question) {
// Update step counter
$(".step-counter").text(
"Step " + (current_question + 1) + " of " + questions.length
);
for (var j = 0; j < question.options.length; j++) {
if (question.options[j].option != "") {
$(".options").append(
"<div class='option'><input type='radio' id='" +
j +
"" +
current_question +
"' value='" +
j +
"' name='" +
current_question +
"' /><label for='" +
j +
"" +
current_question +
"'>" +
question.options[j].option +
"</label></div>"
);
}
}
$("input[name='" + current_question + "']").change(function () {
if (!selected) {
$(this).parent().find("label").addClass("selected");
}
selected = true;
setTimeout(function () {
console.log(current_question);
if (
!isNaN(
parseInt($("input[name='" + current_question + "']:checked").val())
)
) {
chosen = parseInt(
$("input[name='" + current_question + "']:checked").val()
);
answers.push(chosen);
$(".back").show();
if (current_question == 3) {
trigger1_faceCondition = chosen; // Question 4: At the end of the day (face condition)
} else if (current_question == 4) {
trigger2_eyeConcern = chosen; // Question 5: Eye area concerns
} else if (current_question == 5) {
trigger3_skinGoal = chosen; // Question 6: Skin improvement goal (including Redness/rosacea)
} else if (current_question == 6) {
tried = chosen; // Question 7: Customer vs prospect
}
score += questions[current_question].options[chosen].value;
current_question++;
if (current_question == questions.length) {
$(".question").hide();
$(".introduction").hide();
// $(".results").show();
if (Cookies.get("taken") != "1") {
$("html, body").animate(
{
scrollTop: 1,
},
200
);
$(".email h2").text("What is your name and email address?");
$(".email").show();
$(".email form").submit(function (e) {
var emailVal = $("#quiz_form_001 input[name=email]").val();
var nameVal = $("#quiz_form_001 input[name=first_name]").val();
var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Validate name
if (nameVal == "" || nameVal.trim() == "") {
e.preventDefault(); // Add this
alert("Please enter your name.");
return false; // Change to return false
}
// Validate email exists
if (emailVal == "" || emailVal.trim() == "") {
e.preventDefault(); // Add this
//alert("Please enter your email address.");
return false; // Change to return false
}
// Validate email format
if (!emailRegex.test(emailVal)) {
e.preventDefault(); // Add this
//alert("Please enter a valid email address.");
return false; // Change to return false
}
e.preventDefault();
$("html, body").animate(
{
scrollTop: 1,
},
200
);
$(".email").hide();
$(".results").show();
fname = $("input[name='first_name']").val();
Cookies.set("fname", fname);
Cookies.set("tried", tried);
Cookies.set("score", score);
Cookies.set("trigger3_skinGoal", trigger3_skinGoal);
Cookies.set("trigger2_eyeConcern", trigger2_eyeConcern);
Cookies.set("trigger1_faceCondition", trigger1_faceCondition);
showResults();
});
} else {
$(".results").show();
fname = $("input[name='first_name']").val();
Cookies.set("fname", fname);
Cookies.set("tried", tried);
Cookies.set("score", score);
Cookies.set("trigger3_skinGoal", trigger3_skinGoal);
Cookies.set("trigger2_eyeConcern", trigger2_eyeConcern);
Cookies.set("trigger1_faceCondition", trigger1_faceCondition);
showResults();
}
} else {
var question = questions[current_question];
$(".question h2").text(question.question);
$(".options").empty();
loadQuestions(question);
}
}
selected = false;
}, 500);
});
}
});
